import { render, staticRenderFns } from "./IncomingStock.vue?vue&type=template&id=dfcb994c&scoped=true"
import script from "./IncomingStock.vue?vue&type=script&lang=js"
export * from "./IncomingStock.vue?vue&type=script&lang=js"
import style0 from "./IncomingStock.vue?vue&type=style&index=0&id=dfcb994c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb994c",
  null
  
)

export default component.exports